<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="part-1-brown-tales-from-my-land-of-origin">
<h1 style="font-family:Arial; padding-top:180px;">Part 1 <br/>Brown Tales from My Land of Origin</h1>
<p><strong><br/>
</strong></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch007.vue?c4212582